import devicesRaw from "../../../metadata/devices.json";
import React from "react";
import { ModalDataInformation } from "./data_sources_display";

export function LeftInfoPane({ currentDevice, leftPaneInfoRef }) {
  /*
    if (currentDevice?.name === "Upload") {
      return <FileUploader />;
    }*/

  return (
    <div className="w-100 h-100 ms-3 pe-4-5 mb-5">
      {currentDevice?.card_type === "generic" && (
        <div className="card rounded-0 text-start black-hover border-dark" ref={leftPaneInfoRef}>
          <GenericInfoPane currentDevice={currentDevice} />
        </div>
      )}
      {currentDevice?.card_type === "upload" && (
        <div className="card rounded-0 text-start black-hover border-dark">
          <UploadInfoPane />
        </div>
      )}
    </div>
  );
}

function GenericInfoPane({ currentDevice }) {
  const deviceJsonInfo = devicesRaw.find(
    ({ device }) => device === currentDevice?.device
  );

  return (
    <div className="p-4">
      <h4 className="mb-2">{deviceJsonInfo.device}</h4>
      <div>
        <span>{deviceJsonInfo.description}</span>
        <div className="mt-3">
          <h6>Available data streams</h6>
          <p>
            This device can stream the following data to a visualization. Hover
            to learn more.
          </p>
          <ModalDataInformation
            source={deviceJsonInfo.device}
            groupData={true}
          />
        </div>
      </div>
    </div>
  );
}

function UploadInfoPane() {
  return (
    <div className="p-4">
      <h4 className="mb-2">Upload Your Recording</h4>
      <div>
        <p>Upload a .zip file of the recording generated by this app.</p>
        <div className="mt-3">
          <h6>Note</h6>
          <p>
            Uploaded files are not sent to any servers and will remain on your
            computer.
          </p>
        </div>
        <div className="mt-3">
          <h6>Available data streams</h6>
          <p>
            The data streams available for analysis will depend on the devices
            you used during the recording.
          </p>
        </div>
      </div>
    </div>
  );
}
